/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import {UserService} from '../_services/user.service';
import {map, take} from 'rxjs/operators';
import {UserType} from '../_models/user';

@Injectable()
export class NoAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return combineLatest([
      this.userService.isAuthenticated,
      this.userService.currentUser
    ]).pipe(
      take(1),
      map(([isAuth, currentUser]) => {
        if (isAuth) {
          if (currentUser.userType === UserType.Unregistered) {
            this.router.navigate(['/guest/dashboard']);
          } else {
            this.router.navigate(['/app/dashboard']);
          }
          return false;
        }
        return true;
      })
    );
  }
}
